import React from 'react';
import './FilterBadge.scss';

export const FilterBadge = ({ filterLabel, filterValue, removeFilter }) => (
    <div className={'filter-badge'}>
        <span>{filterLabel}</span>
        <i
            className={'material-icons'}
            onClick={() => removeFilter(filterValue)}
        >
            close
        </i>
    </div>
);
